import { LocalDateTime } from "./JSJodaJSON";
import { NursingQuestionId } from "./ObjectIds";

export interface VitalExtraDetails {
  measuredAt: LocalDateTime | null;
  method: VitalMethodType | null;
  comments: string | null;
  unit: VitalUnitType | null;
}

export interface VitalExtraDetailsWithAnswer extends VitalExtraDetails {
  answer: string | string[] | null;
}

export const VitalType = {
  bloodPressure: NursingQuestionId.wrap(34),
  pulseRate: NursingQuestionId.wrap(35),
  respirationRate: NursingQuestionId.wrap(111),
  bodyTemperature: NursingQuestionId.wrap(112),
};

export enum VitalUnitType {
  FAHRENHEIT = "FAHRENHEIT",
  MMHG = "mmHg",
  BreathPerMinute = "Breaths Per Minute",
  BeatsPerMinute = "Beats Per Minute",
}

export enum VitalMethodType {
  RightArm = "Right Arm",
  LeftArm = "Left Arm",
  Sitting = "Sitting",
  Laying = "Laying",
  Standing = "Standing",
  Regular = "Regular",
  Irregular = "Irregular",
  Oral = "Oral",
  Axillary = "Axillary",
  Rectal = "Rectal",
  RemoteForehead = "Remote/Forehead",
}

export const VitalUnitNames = new Map<VitalUnitType, string>([
  [VitalUnitType.BeatsPerMinute, "Beats Per Minute"],
  [VitalUnitType.BreathPerMinute, "Breath Per Minute"],
  [VitalUnitType.FAHRENHEIT, "Fahrenheit"],
  [VitalUnitType.MMHG, "mmHg"],
]);

export const VitalMethodNames = new Map<VitalMethodType, string>([
  [VitalMethodType.RightArm, "In the Right Arm"],
  [VitalMethodType.LeftArm, "In the Left Arm"],
  [VitalMethodType.Sitting, "Sitting"],
  [VitalMethodType.Laying, "Laying"],
  [VitalMethodType.Standing, "Standing"],
  [VitalMethodType.Regular, "Regular"],
  [VitalMethodType.Irregular, "Irregular"],
  [VitalMethodType.Oral, "Oral"],
  [VitalMethodType.Axillary, "Axillary"],
  [VitalMethodType.Rectal, "Rectal"],
  [VitalMethodType.RemoteForehead, "Remote / Forehead"],
]);

export type VitalType = "BLOOD_PRESSURE" | "REGULAR_NUMBER";
export type VitalAnswerType = "BASE_ANSWER" | "MEASURED_AT" | "METHOD" | "COMMENTS" | "UNIT";

export interface VitalExtraDetails {
  measuredAt: LocalDateTime | null;
  method: VitalMethodType | null;
  unit: VitalUnitType | null;
  comments: string | null;
}
